import dayjs from "dayjs";

const getFormat = (values: any, data: any) => {
    (data ?? []).map((item: any) => {
        var keys = Object.keys(values).filter((k: any) => (k.toLowerCase().indexOf(item.customName.toLowerCase()) >= 0));
        if (keys.length > 0) {
            var key = keys[0];
            switch (item.fillFormatEnum) {
                case 1:
                    values[key] = values[key].toString();
                    break;
                case 2:
                    values[key] = values[key] ? dayjs(values[key]).format('YYYY-MM-DD') : '';
                    break;
                case 3:
                    values[key] = values[key] ? dayjs(values[key]).format('YYYY-MM-DD HH:mm:ss') : '';
                    break;
                default:
                    break;
            }
        }
    })
    return values;
}
const setFormat = (values: any, data: any) => {
    var result = {
        ...values
    };
    (data ?? []).map((item: any) => {
        var keys = Object.keys(result).filter((k: any) => (k.toLowerCase().indexOf(item.customName.toLowerCase()) >= 0));
        if (keys.length > 0) {
            var key = keys[0];
            if (item.fillFormatEnum == 2 || item.fillFormatEnum == 3) {
                result[key] = result[key] ? dayjs(result[key]) : '';
            }
        }
    })
    return result;
}
const initColumns = (columns: any, startIdx: number, data: any) => {
    (data ?? []).map((item: any) => {
        if (item.isActive) {
            columns.splice(startIdx, 0, {
                title: item.showLabel,
                dataIndex: item.customName.toLowerCase(),
                key: item.customName.toLowerCase(),
                width: 150,
                ellipsis: true
            });
            startIdx++;
        }
    });
    return columns;
}
export default {
    getFormat,
    setFormat,
    initColumns,
}